<template>
  <div>
    <account-info-form :currentUser="currentUser" />
  </div>
</template>

<script>
import AccountInfoForm from '../components/AccountInfoForm';

export default {
  name: 'EditAccountInfo',
  components: {
    AccountInfoForm,
  },
  data() {
    return {
      currentUserId: '',
    };
  },
  computed: {
    currentUser() {
      return this.$store.getters['auth/currentUser'];
    },
  },
};
</script>

<style lang="sass" scoped></style>
